import coreUI from "core-fe-lib/components-shadcn/i18n/en-US";
import core from "./core"; // hub-only: core.features
import layout from "./layout"; // hub-only: layout.navigation.<module>
import contact from "./modules/contact";

// Module-specific messages (care, scholar, automation, etc.) are owned by
// each module and merged into i18n at startup via mergeModuleMessages()
// in main.ts.

// Shell + admin/auth/mfa labels come from core-fe-lib; hub augments them with
// its own per-module navigation entries and its feature catalog.
export default {
  locale: "en-US",
  ...coreUI,
  layout: {
    ...coreUI.layout,
    navigation: {
      ...coreUI.layout.navigation,
      ...layout.navigation,
    },
  },
  core: {
    ...coreUI.core,
    ...core, // hub `core.features`
  },
  contact,
};
